module.exports = __webpack_public_path__ + "static/media/difficulty.d187cd03.png";